import { useQuery } from 'react-query';
import { useAuth0 } from '@auth0/auth0-react';
import setToken from '../../utils/api';
import { ConversationDetail } from '../../types/IAiConversation';

export const AI_CONVERSATION_KEY = 'ai-conversation';

// One conversation with its messages, loaded when the person opens it from the list. No
// keepPreviousData: conversation B must never be seeded with A's messages.
export default function useAiConversation(id: number | null) {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<ConversationDetail, Error>(
    [AI_CONVERSATION_KEY, id],
    async () => {
      const token = await getAccessTokenSilently();
      const api = await setToken(token);
      const response = await api.get<ConversationDetail>(
        `api/ai/conversations/${id}`,
      );
      if (response.status !== 200)
        throw new Error('Could not load the conversation');
      return response.data;
    },
    { enabled: id != null, staleTime: Infinity, refetchOnWindowFocus: false },
  );
}
